module.exports = __webpack_public_path__ + "img/close.6c379ad0.svg";